/*
 * Product cards whose product has a video (snippets/card-gallery.liquid renders a hidden
 * <video data-orbit-card-video>) play it, muted and looping, while the pointer is over the
 * card, and pause it when the pointer leaves. Only on devices that can hover, and never
 * with reduced motion. The source is set on the first hover, so a grid downloads nothing
 * until someone points at a card; the video fades in only once it is actually playing.
 */
(() => {
  const canHover = matchMedia('(hover: hover) and (pointer: fine)');
  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  const cardOf = (target) => target.closest && target.closest('.card-gallery');

  // Shopify transcodes every video to 480p/720p/1080p, but Liquid only hands the card
  // the 1080p file. The product's .js lists them all; take the smallest at 480p or more.
  const smallSource = async (video) => {
    try {
      const product = await (await fetch(`${video.dataset.productUrl}.js`)).json();
      const sources = (product.media || [])
        .filter((m) => m.media_type === 'video')
        .flatMap((m) => m.sources || [])
        .filter((s) => s.format === 'mp4' && s.height >= 480)
        .sort((a, b) => a.height - b.height);
      return sources[0]?.url || video.dataset.src;
    } catch {
      return video.dataset.src;
    }
  };

  const start = async (card) => {
    const video = card.querySelector('[data-orbit-card-video]');
    if (!video || !canHover.matches || calm.matches) return;
    card.dataset.orbitHover = '1';
    if (!video.src && !video.dataset.loading) {
      video.dataset.loading = '1';
      video.src = video.dataset.productUrl ? await smallSource(video) : video.dataset.src;
      video.addEventListener('playing', () => video.classList.add('is-playing'));
    }
    video.muted = true;
    if (card.dataset.orbitHover === '1' && video.src) video.play().catch(() => {});
  };

  const stop = (card) => {
    const video = card.querySelector('[data-orbit-card-video]');
    if (!video) return;
    card.dataset.orbitHover = '';
    video.pause();
    video.classList.remove('is-playing');
  };

  document.addEventListener('pointerover', (event) => {
    const card = cardOf(event.target);
    if (card && !card.contains(event.relatedTarget)) start(card);
  });
  document.addEventListener('pointerout', (event) => {
    const card = cardOf(event.target);
    if (card && !card.contains(event.relatedTarget)) stop(card);
  });
})();
